import { gql } from "apollo-angular";

export const WIRELESS_SUBSCRIPTIONS_LOCATIONS_QUERY = gql`
  query WirelessListQuery($customer: UUID!) {
    subscriptions: wirelessList(searchFilter: { accessCustomerId: $customer }) {
      page {
        subscriptionId
        description
        customerDescription
        location {
          city
        }
      }
    }
  }
`;
